import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmrReadyPage } from './emr-ready.page';

const routes: Routes = [
  {
    path: '',
    component: EmrReadyPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmrReadyPageRoutingModule {}
